import React, { useState, useEffect } from "react";
import { httpClient } from "../../api/http";
import toast from "react-hot-toast";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FaChevronDown } from "react-icons/fa";
import useSWR from "swr";
import ads1 from "../../assets/ads1.png";
import ads2 from "../../assets/ads2.png";
import { useAuthContext } from "../../auth";
import { Navigate } from "react-router-dom";
import { useNewRedirect } from "../../utils/hooks";
export function AdsSetting() {
  const [videoUrl, setVideoUrl] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState(30);
  const { isLoggedIn, isGuest } = useAuthContext();
  const redirect = useNewRedirect();

  const { data: adsData } = useSWR(["/v1/thaihealth/getting_ads_data/"]);

  useEffect(() => {
    if (adsData) {
      setSelectedDuration(adsData.duration_page);
    }
  }, [adsData]);

  const handleSave = async () => {
    if (!videoUrl) {
      toast.error("Please enter a URL");
      return;
    }

    setIsSaving(true);
    try {
      const toastId = toast.loading("Saving advertisement...");
      await httpClient.post("/v1/thaihealth/setting_ads_data/", {
        url: videoUrl,
        duration: selectedDuration,
      });
      toast.dismiss(toastId);
      toast.success("Advertisement saved successfully");
    } catch (error) {
      console.error("Error saving advertisement:", error);
      toast.error("Failed to save advertisement");
    } finally {
      setIsSaving(false);
    }
  };

  if (!isLoggedIn || isGuest) {
    return <Navigate to={`/login${redirect}`} replace />;
  }

  return (
    <div className="h-screen flex flex-col bg-[#F9FAFF] font-sans">
      <p
        className="text-[18px] font-semibold px-4 py-2"
        style={{
          background:
            "linear-gradient(77deg, #0E7EE4 9.22%, #14B8B4 90.78%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        Advertisement
      </p>
      <div className="border-b border-[#DBE4FF] mt-1 mx-2"></div>
      <div className="flex">
        <div
          className="w-[30vw] p-3 bg-white rounded-xl border border-[#EDEFF9] mt-[24px] ml-[40px] flex flex-col gap-[10px] h-fit"
          style={{
            boxShadow: "1px 3px 20px 0px rgba(154, 170, 207, 0.10)",
          }}
        >
          <p className="text-[14px] font-semibold text-[#065BA9]">
            ตั้งค่าคลิปวีดีโอหน้า Ads
          </p>
          <input
            type="text"
            className="w-full text-[10px] border-2 border-[#DBE4FF] bg-white rounded-lg placeholder:text-[#9CA3AF] placeholder:text-[10px] px-2 h-[36px]"
            placeholder="URL"
            onChange={(e) => setVideoUrl(e.target.value)}
          />
          <div className="w-full relative z-[1] mt-2">
            <Menu>
              <MenuButton className="w-full inline-flex items-center justify-between border-2 border-[#DBE4FF] rounded-lg bg-white py-1.5 px-3 font-semibold shadow-inner shadow-white/10">
                <p className="text-[12px] text-[#4B5563]">
                  {selectedDuration} seconds
                </p>
                <FaChevronDown className="w-[20px] fill-[#6B7280]" />
              </MenuButton>

              <MenuItems
                transition
                anchor="bottom"
                className="w-[26%] origin-top-right text-[14px] text-[#4B5563] rounded-[10px]"
                style={{
                  boxShadow: "0px 6px 6px 1px rgba(156, 163, 175, 0.18)",
                }}
              >
                <MenuItem>
                  <button
                    className="group flex w-full items-center gap-2 py-1.5 px-3 data-[focus]:bg-[#F9FAFF] bg-white rounded-t-[10px]"
                    onClick={() => setSelectedDuration(90)}
                  >
                    90 seconds
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    className="group flex w-full items-center gap-2 py-1.5 px-3 data-[focus]:bg-[#F9FAFF] bg-white"
                    onClick={() => setSelectedDuration(120)}
                  >
                    120 seconds
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    className="group flex w-full items-center gap-2 py-1.5 px-3 data-[focus]:bg-[#F9FAFF] bg-white"
                    onClick={() => setSelectedDuration(150)}
                  >
                    150 seconds
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    className="group flex w-full items-center gap-2 py-1.5 px-3 data-[focus]:bg-[#F9FAFF] bg-white rounded-b-[10px]"
                    onClick={() => setSelectedDuration(180)}
                  >
                    180 seconds
                  </button>
                </MenuItem>
              </MenuItems>
            </Menu>
            <p className="absolute top-[-18%] left-[3%] z-[2] bg-white text-[#6B7280] text-[10px] font-sans">
              ระยะเวลาของหน้า Advertisement
            </p>
          </div>
          <button
            onClick={handleSave}
            disabled={isSaving}
            className={`h-[24px] bg-[#0E7EE4] rounded-[5px] text-white text-[10px] w-fit px-2 py-[6px] self-end ${
              isSaving ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isSaving ? "กำลังบันทึก..." : "บันทึก"}
          </button>
        </div>
        <div className="w-[30vw] p-3 bg-[#DBE4FF] rounded-xl border border-[#EDEFF9] mt-[24px] ml-[40px] flex flex-col gap-[10px] h-fit">
          <p className="text-[14px] font-semibold text-[#065BA9]">
            แนวทางการนำวีดีโอขึ้นหน้า Advertisement
          </p>
          <p>1. ตัดต่อและรวมคลิปและรูปภาพใน 1 คลิป</p>
          <p>2. อัพโหลดคลิปขึ้น Youtube</p>
          <p>3. คลิกปุ่ม Share ที่คลิปบน Youtube</p>
          <p>4. คลิก "Embed"</p>
          <p>5. คัดลอก Link ในเครื่องหมายคำพูดหลัง src="</p>
          <p>6. วาง Link บนกล่อง URL ด้านซ้าย</p>
          <p>7. เลือกระยะเวลาของหน้า Advertisement ที่ต้องการ</p>
          <p className="pl-4">
            a. หากวีดีโอสั้นกว่าระยะเวลาที่เลือก →
            วีดีโอจะเล่นวนจนกว่าจะครบระยะเวลาที่เลือก และตัดไปหน้าถัดไป
          </p>
          <p className="pl-4">
            b. หากวีดีโอยาวกว่าระยะเวลาที่เลือก →
            วีดีโอจะถูกตัดไปหน้าถัดไปเมื่อครบระยะเวลาที่เลือกไว้
          </p>
          <p className="text-[#FD1010] mt-4">
            *เมื่อคลิกปุ่ม "บันทึก" คลิปจะถูกนำขึ้นหน้า Advertisement ทันที*
          </p>
        </div>
        <div className="w-[30vw] p-3 bg-white rounded-xl border border-[#EDEFF9] mt-[24px] ml-[40px] flex flex-col gap-[10px]">
          <img src={ads1} alt="ads-setting-1" />
          <img src={ads2} alt="ads-setting-1" />
        </div>
      </div>
    </div>
  );
}
